CollectionWithHelpers = require 'app/scripts/models/collections/internal/collection-with-helpers'
List = require 'app/scripts/models/list'
Util = require 'app/scripts/lib/util'

class ListList extends CollectionWithHelpers
  model: List
  initialize: (models, options) ->
    @listenTo @, 'change:pos', @sort
    @board = options.board
    return

  comparator: (list) -> list.get('pos') || 0

  calcPos: (index, list, includeList) ->
    Util.calcPos(index, @, list, null, includeList)

  url: ->
    "/1/boards/#{ @board.id }/lists"

module.exports = ListList
